import { NgFor, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TrackByFunction } from "@angular/core";
import { IN_LIST_ANIMATION } from "src/app/core/animations/list-animation";
import { LaunchpadNewsCardProps, LaunchpadTileConfig } from "../../container/launchpad.interfaces";
import { BufferCardComponent } from "../buffer-card/buffer-card.component";
import { ModuleCardComponent } from "../module-card/module-card.component";

@Component({
  selector: "tpm-cards-grid",
  templateUrl: "cards-grid.component.html",
  styleUrls: ["cards-grid.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgFor, ModuleCardComponent, BufferCardComponent],
  animations: [IN_LIST_ANIMATION]
})
export class CardsGridComponent {
  @Output() readonly moduleCardClicked = new EventEmitter<LaunchpadTileConfig>();
  @Output() readonly storytellerButtonClicked = new EventEmitter<LaunchpadTileConfig>();
  @Output() readonly leadButtonClicked = new EventEmitter<LaunchpadTileConfig>();
  @Output() readonly productButtonClicked = new EventEmitter<LaunchpadTileConfig>();
  @Output() readonly innerNewsCardButtonClicked = new EventEmitter<LaunchpadTileConfig>();
  @Output() readonly newsButtonClicked = new EventEmitter<void>();

  @Input() isMobile: boolean | undefined;
  @Input() list: Array<LaunchpadTileConfig> | undefined;
  @Input() news: Record<string | `module-${number}`, LaunchpadNewsCardProps> | undefined;

  readonly trackByName: TrackByFunction<LaunchpadTileConfig> = (_, tile) => tile.name;
}
